import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ClusterPartWithParent extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   id: number;
   clusterGroupId: number;
   clusterPathId: number;
   clusterPathName: string;
   clusterPartLabel: string;
   clusterPartName: string;
   clusterPartNode: string;
   precedence: number;
   parentNode: string;
   superClusterId: number;
   colorCode: string;
}

